/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Associated_ClientsInputs */

const en_users_form_associated_clients = /** @type {(inputs: Users_Form_Associated_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Associated Clients`)
};

const pt_br2_users_form_associated_clients = /** @type {(inputs: Users_Form_Associated_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clientes Associados`)
};

/**
* | output |
* | --- |
* | "Associated Clients" |
*
* @param {Users_Form_Associated_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_associated_clients = /** @type {((inputs?: Users_Form_Associated_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Associated_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_associated_clients(inputs)
	return pt_br2_users_form_associated_clients(inputs)
});